<div id="snackbar" [ngClass]="{ visible: isVisible }" (click)="close()" *ngIf="message">
	<div>
		<span [translate]="message.translate" [translateParams]="message.translateParams"></span>
	</div>
</div>
